import { store } from "../../redux/storeConfig/store";

const endpoint = (path) =>
  `${process.env.REACT_APP_SERVER_URL || ""}${path}`;

const token = () => {
  try {
    const user = JSON.parse(
      localStorage.getItem("connectToFitGymPanelUser") || "{}"
    );
    return user.token || "";
  } catch (error) {
    return "";
  }
};

const quietPost = async (path, data) => {
  try {
    const res = await fetch(endpoint(path), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-auth": token(),
      },
      body: JSON.stringify(data),
    });
    if (!res.ok) return null;
    const body = await res.json();
    return body && body.data;
  } catch (error) {
    return null;
  }
};

const sessionId = () => {
  const voice = store.getState().voiceAdd || {};
  return voice.sessionId || null;
};

export const trackVoiceAddEvent = (type, payload) => {
  const id = sessionId();
  if (!id) return Promise.resolve(null);
  return quietPost("voice-add/session/event", {
    sessionId: id,
    type,
    payload: payload || {},
  });
};

export const trackVoiceAddConfirm = (results) => {
  const id = sessionId();
  if (!id) return Promise.resolve(null);
  return quietPost("voice-add/session/confirm", {
    sessionId: id,
    results: (results || []).map((item) => ({
      draft: item.draft
        ? {
            id: item.draft.id,
            type: item.draft.type,
            label: item.draft.label,
          }
        : null,
      outcome: item.outcome,
      message: item.message,
      createdId: item.createdId,
    })),
  });
};

export const endVoiceAddSession = (reason) => {
  const id = sessionId();
  if (!id) return Promise.resolve(null);
  return quietPost("voice-add/session/end", {
    sessionId: id,
    reason: reason || "close",
  });
};
